<div class="container">
    @if (room.users.length !== 1) {
        <div class="header">
            <div class="full-name">
                <i [style.background]="room.target.color">{{ room.target.initials }}</i>
                <div class="small-name" [matTooltip]="room.target.displayName">
                    <span>Conversation avec&nbsp;</span>
                    <strong class="name">{{ room.target.displayName }}</strong>
                </div>
                @if (room.messages.length !== 0) {
                    <mat-icon class="icon save-icon" (click)="onSave()" matTooltip="Sauver la conversation">save</mat-icon>
                }
            </div>
        </div>
    }

    @if (room.users.length === 1) {
        <div class="header header-add" [ngClass]="{ 'header-add-max': isContactsListExpanded, 'header-add-min': !isContactsListExpanded }">
            <form [formGroup]="searchContactForm" novalidate>
                <!-- <div class="search">
        <mat-icon class="icon add-icon" (click)="onAddContact()" matTooltip="Ajouter un contact" matTooltipPosition="below">add_circle_outline</mat-icon>
        <input *ngIf="isSearchFormVisible" id="contact-add-input" matInput type="text" placeholder="Ajouter une personne" formControlName="userControlName" (input)="onSearchInputChange();" autocomplete="off">
        <ul *ngIf="isSearchFormVisible && contactSearchResult && contactSearchResultVisible === true" class="contact-list">
          <li *ngFor="let contact of contactSearchResult" (click)="addUser(contact);" class="contact">
            <span>{{contact}}</span>
          </li>
          <li *ngIf="contactSearchResult.length === 0">Pas de contact trouvé</li>
        </ul>
      </div> -->
                <div class="search-contact-container">
                    <input
                        class="search-contact-input"
                        #selectControl
                        type="text"
                        placeholder="Ajouter une personne"
                        matInput
                        formControlName="userControlName"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete
                        #auto="matAutocomplete"
                        [displayWith]="displayLabel"
                        (opened)="opened()"
                        (closed)="closed()"
                        (optionSelected)="onContactSelected($event)"
                        class="tchat-add-user-autocomplete">
                        @for (contact of filteredContacts | async; track contact.login) {
                            <mat-option [value]="contact.login">
                                {{ contact.displayName }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                    <fa-icon [icon]="faCaretDown" (click)="selectControl.focus()"></fa-icon>
                </div>
                @if (!isContactsListExpanded) {
                    <mat-icon class="icon expand-icon" (click)="isContactsListExpanded = true" matTooltip="Agrandir la zone des personnes" matTooltipPosition="below">
                        expand_more
                    </mat-icon>
                }
                @if (isContactsListExpanded) {
                    <mat-icon class="icon expand-icon" (click)="isContactsListExpanded = false" matTooltip="Réduire la zone des personnes" matTooltipPosition="below">
                        expand_less
                    </mat-icon>
                }
            </form>
            <div class="contacts form-item">
                <mat-chip-listbox multiple>
                    @for (user of roomUsers; track user.login) {
                        <mat-chip-option selectable="false" removable="true" (removed)="removeUser(user)">
                            {{ user.displayName }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
            </div>
        </div>
    }

    <div class="historics" [ngClass]="{ 'historics-min': isContactsListExpanded }">
        <app-tchat-room-messages [isLiveTchat]="true" [sourceUser]="connectedUser" [room]="room"></app-tchat-room-messages>
    </div>

    <form [formGroup]="messageForm" novalidate>
        <div class="message">
            <textarea matInput formControlName="messageControlName" placeholder="Tapez votre message" rows="3" (keyup.enter)="onMessageSend()"></textarea>
            <mat-icon class="icon send-icon" (click)="onMessageSend()" matTooltip="envoyer le message">send</mat-icon>
        </div>
    </form>
</div>
